<template>
  <a
    v-if="isActive && _level"
    href="https://wan.xunlei.com/vip-rights"
    class="xw-vip"
    :class="`xw-vip-${_level}`"
    title="VIP等级"
    target="_blank"
    @click="$emit('click')"
  >
  </a>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      default: 'active'
    },
    level: [Number, String]
  },
  computed: {
    isOutter() {
      return this.level !== undefined
    },
    _level() {
      return this.isOutter ? this.level : this.userLevel.level
    },
    isActive() {
      return this.isOutter ? this.state : this.userLevel.state
    },
    userLevel() {
      return this.$store.state.userLevel
    }
  }
}
</script>
